module.exports = new __parcel__URL__("linkedIn.72741b7b.png").toString();